import React from "react";
// import backArrow from "../../../assets/icons/Back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bettingService from "../../../api/services/bettingService";
import { useState } from "react";
import { useEffect } from "react";
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
// import Share from '../../../assets/icons/share.png';
import { IoIosArrowBack } from "react-icons/io";

const SelectedMathesDetail = ({ setIsLoading }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedMatchesDetail } = useSelector(state => state.sidebar);
    const { id } = useParams();
    const { t } = useTranslation();
    const [selectedMatches, setSelectedMatches] = useState([]);
    const language = localStorage.getItem("language");

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleBackClick = async () => {
        await handleSongClick();
        navigate("/selected-matches");
    };

    useEffect(() => {
        setIsLoading(true);
        bettingService.bettingHistoryDetails({
            "gamblingId": Number(id),
            "status": "Inplay"
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    const sortedData = data.slice().sort((a, b) => {
                        const dateA = new Date(
                            a.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + a.eventDate.split(' ')[1]
                        );
                        const dateB = new Date(
                            b.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + b.eventDate.split(' ')[1]
                        );
                        return dateA - dateB;
                    });
                    setSelectedMatches(sortedData)
                }
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                if (err.response.status === 401) {
                    // Redirect to the login page
                    navigate("/login");
                } else {
                    console.error("API request error:", err);
                }
            });
    }, [id, navigate, setIsLoading]);

    return (
        <div className="w-full h-[100dvh] flex flex-col bg-slate-100 dark:bg-bg_header_dark overflow-hidden">
            <div className="flex justify-start items-center py-2 border-b dark:border-slate-700 dark:shadow-sm bg-bg_header dark:bg-bg_header_dark">
                <button
                    className="top-3 left-5 w-10 h-10
                    rounded-full drop-shadow-lg flex justify-center items-center text-blue-700 text-4xl"
                    onClick={handleBackClick}
                >
                    {/* <img src={backArrow} alt="Back Arrow" /> */}
                    <IoIosArrowBack size={25} className="text-white" />
                </button>
                <div className="flex-1 justify-center items-center">
                    <h3 className="text-white mr-7 text-center">
                        {t("selectedMatches")}
                    </h3>
                </div>
            </div>
            <div className="text-slate-600 dark:text-league_text text-end text-xs mr-3 mt-2 font-dangrek">BetID : {selectedMatchesDetail?.postingNo}</div>
            <div className="flex-1 px-1.5 overflow-auto">
                {selectedMatches.map((match, index) => {
                    const bettedTeam = language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
                    const oppositeTeamName = language === "en" ? match?.oppositeTeamName : match?.oppositeTeamNameMyan;
                    return (
                        <div key={index} className="flex flex-col py-3 px-1.5 border border-slate-300 dark:border-slate-600 bg-white dark:bg-k_groupBgColorEight rounded-xl my-1">
                            <div className="flex justify-between items-center mb-2 font-thin text-xs sm:text-sm md:text-base text-white dark:text-white">
                                <p className="text-left rounded-lg px-2 text-slate-600 dark:text-time_dark font-dangrek">
                                    {match?.eventDate}
                                </p>
                            </div>
                            <div className="grid grid-cols-9 mb-1">
                                <div
                                    className={`${match?.home === true
                                        ? "bg-k_selectionBgColor shadow-2xl shadow-blue-300 text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-l-full py-2 px-1 flex items-center col-span-4`}
                                >
                                    <h3
                                        className={`ml-auto font-normal text-center  dark:text-white text-sm ${match?.home === true ? "text-k_selectionFgColor" : "text-k_teamsFgColor"
                                            } sm:text-base md:text-base ${match?.isHomeBodyOdd === false
                                                ? "flex flex-1 items-center justify-center"
                                                : "flex flex-1 justify-center"
                                            }`}
                                    >
                                        {match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                    {match.isHomeBodyOdd === true && (
                                        <h3 className="bg-k_priceBgColor p-1 font-bold rounded-lg text-k_priceFgColor text-xxs text-xs sm:text-sm md:text-base whitespace-nowrap">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                </div>
                                <div className="flex justify-center items-center text-center text-k_goalscoreFgColor text-sm w-full bg-k_goalscoreBgColor font-dangrek">
                                    {match?.homeResult === "NS" 
                                        ? "VS" 
                                        : `${match?.homeResult} - ${match?.awayResult}`
                                    }
                                </div>
                                <div
                                    className={`${match?.away === true
                                        ? "bg-k_selectionBgColor shadow-2xl shadow-blue-300 text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        }  rounded-r-full py-2 px-1 flex justify-center items-center col-span-4`}
                                >
                                    {match?.isHomeBodyOdd === false && (
                                        <h3 className="bg-k_priceBgColor p-1 font-bold rounded-lg text-k_priceFgColor text-xxs text-xs sm:text-sm md:text-base">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                    <h3
                                        className={` flex flex-1 w-full justify-center text-center font-normal dark:text-white text-sm sm:text-base md:text-base ${match?.isHomeBodyOdd === true &&
                                            "flex flex-1 justify-center items-center"
                                            }`}
                                    >
                                        {!match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                </div>
                            </div>
                            <div className="grid grid-cols-9">
                                <div
                                    className={`${match?.overs === true
                                        ? "bg-k_selectionBgColor shadow-2xl shadow-blue-300 text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-l-full p-1 col-span-4`}
                                >
                                    <h3 className="font-normal text-center  dark:text-white text-sm sm:text-sm md:text-base py-1">
                                        {t("goalOver")}
                                    </h3>
                                </div>
                                <div className="cursor-not-allowed text-center bg-slate-200 p-1 flex justify-center items-center ">
                                    <h3 className="font-bold text-center text-k_priceFgColor text-xs sm:text-sm md:text-base whitespace-nowrap">
                                        {match?.goalOdd}
                                    </h3>
                                </div>
                                <div
                                    className={`${match?.under === true
                                        ? "bg-k_selectionBgColor shadow-2xl shadow-blue-300 text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } text-center rounded-r-full p-1 col-span-4 flex justify-center items-center`}
                                >
                                    <h3 className="font-normal text-center  dark:text-white text-sm sm:text-sm md:text-base">
                                        {t("goalUnder")}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="w-full bg-bg_header dark:bg-bg_header_dark 
                dark:border dark:border-slate-700 
                rounded-t-lg shadow-md py-4 px-6 text-white">

                {/* Date */}
                <div className="flex justify-end mb-3">
                    <p className="text-[11px] text-betID font-medium">
                        {moment(selectedMatchesDetail?.createdDate).format(
                            "DD.MM.YYYY • h:mm A"
                        )}
                    </p>
                </div>

                {/* Info rows */}
                <div className="space-y-2">
                    <div className="flex justify-between items-center border-b border-white/10 pb-1">
                        <span className="text-sm opacity-80">
                            {t("betAmount")}
                        </span>
                        <span className="font-semibold text-sm">
                            {parseInt(selectedMatchesDetail?.amount).toLocaleString()}
                        </span>
                    </div>

                    <div className="flex justify-between items-center">
                        <span className="text-sm opacity-80">
                            {t("teamCount")}
                        </span>
                        <span className="font-semibold text-sm">
                            {selectedMatchesDetail?.teamCount}
                        </span>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default SelectedMathesDetail;
